"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Card = ({ children, version = "white", onPress, flat }) => {
    return ((0, jsx_runtime_1.jsx)("div", { className: `card border bg-${version} rounded-2 ${flat ? '' : 'shadow'} overflow-hidden cursor-pointer`, onClick: onPress, style: onPress ? { cursor: 'pointer' } : {}, children: children }));
};
exports.Card = Card;
